import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { router } from '@/router';
import type { IUserInfo } from '../types/user';

interface IUserState {
	token: string | null;
	userInfo: IUserInfo | null;
	setAuth: (token: string, userInfo: IUserInfo) => void;
	clearAuth: () => void;
}

export const useUserStore = create<IUserState>()(
	persist(
		(set) => ({
			token: null,
			userInfo: null,
			setAuth: (token: string, userInfo: IUserInfo) => set({ token, userInfo }),
			clearAuth: () => {
				localStorage.removeItem('token');
				set({ token: null, userInfo: null });
				router.navigate('/login');
			},
		}),
		{
			name: 'user-storage',
		},
	),
);
